let constants = {
  CONTAINS: "Contains",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  EDIT: "Edit",
  ADD: "Add",
  DELETE: "Delete",
  MENUS: {
    Admin: [
      { subMenu: "Role and Authorization", path: "/role" },
      { subMenu: "Maintain User", path: "/user" },
    ],
    Maintenance: [
      { subMenu: "Maintain Vendor Details", path: "/vendors" },
      { subMenu: "Tagging", path: "/finance" },
      { subMenu: "Serial Number Dispatch Details", path: "/specialcases" },
      { subMenu: "Maintain Product Quantity", path: "/quantity" },
      { subMenu: "Unblock Serial Number", path: "/unblockSerialNo" }
    ],
    Report: [
      { subMenu: "Validation Log Report", path: "/report" },
      { subMenu: "Serial Number Dispatch", path: "/serialnoDispatch" },
      { subMenu: "Branch Validation Log Report", path: "/branch-validation-log" }
    ],
  },
  CONFIRMATION_BOX_CONFIG: {
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true,
    showCloseButton: true,
    customClass: "swal-confirmation",
  }
};


module.exports = Object.freeze(constants);
